export default {
  title: 'Profil',
  fields: {
    name: {
      label: 'Nom',
      placeholder: 'Saisir le nom du restaurant',
    },
    short_name: {
      label: 'Nom abrégé',
      placeholder: 'Saisir le nom abrégé du restaurant',
      tooltip:
        'Les noms par défaut des restaurants sont parfois très longs et peuvent contenir des informations secondaires. Dans certains cas (ex. : pour des notifications plus courtes), une version abrégée est nécessaire.',
    },
    phone_number: {
      label: 'Numéro de téléphone',
      placeholder: 'Saisir le numéro de téléphone du restaurant',
    },
    email: {
      label: 'E-mail',
      placeholder: "Saisir l'e-mail du restaurant",
    },
    slug: {
      label: 'Slug',
      placeholder: 'Slug de la marque',
    },
    language: {
      label: 'Langue',
      placeholder: 'Utiliser le défaut du groupe',
      tooltip:
        'La langue vue par les clients sur la boutique en ligne de ce restaurant, et la langue par défaut pour son personnel. Laissez vide pour suivre la langue de la marque. Le personnel peut toujours choisir sa propre langue pour sa vue.',
    },
    sms_name: {
      label: 'Nom SMS',
      placeholder: "Nom d'affichage SMS",
    },
    instagram_link: {
      label: 'Lien Instagram',
      placeholder: 'Saisir le lien Instagram du restaurant',
    },
    website_link: {
      label: 'Lien du site web',
      placeholder: 'Saisir le lien du site web du restaurant',
    },
    impressum_link: {
      label: 'Lien Impressum',
      placeholder: 'Saisir le lien Impressum du restaurant',
    },
    timezone: {
      label: 'Fuseau horaire',
      placeholder: 'Rechercher une ville ou un fuseau horaire',
      tooltip:
        "Le fuseau horaire dans lequel ce restaurant opère. Il détermine les horodatages des commandes, les horaires d'ouverture et les créneaux de commandes planifiées. Il a été défini à partir de l'adresse du restaurant lors de sa création — corrigez-le ici si nécessaire.",
    },
    time_format: {
      label: "Format de l'heure",
      placeholder: 'Utiliser le format par défaut du pays',
      tooltip:
        'Comment les horaires sont affichés à votre équipe, dans le tableau de bord et le portail de commandes. Laissez vide pour suivre la convention de la région du restaurant.',
      options: {
        '12h': '12 heures (5:30 pm)',
        '24h': '24 heures (17:30)',
      },
    },
    primary_color: {
      label: 'Couleur principale',
    },
    restaurant_type: {
      label: 'Type de restaurant & modèle de service',
    },
    cuisine_types: {
      label: 'Catégories alimentaires & types de cuisine',
    },
  },
  test_restaurant: {
    title: 'Restaurant test',
    description:
      "Faites de celui-ci votre restaurant test pour essayer l'impression, les e-mails, les commandes et les intégrations en production. Il continue de fonctionner comme n'importe quel autre restaurant et n'est jamais facturé. Vous ne pouvez avoir qu'un seul restaurant test.",
    description_test:
      "Ceci est votre restaurant test. Il fonctionne comme n'importe quel autre restaurant et n'est jamais facturé. Les e-mails et SMS clients concernant ses commandes commencent par [TEST].",
    mark: 'Marquer comme restaurant test',
    remove: 'Retirer la désignation Test',
    slot_taken: "Vous avez déjà un restaurant test ({{name}}). Retirez d'abord la désignation Test de celui existant.",
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    info_updated: 'Paramètres mis à jour avec succès',
  },
};
